if (process.env.NODE_ENV === 'production') { // eslint-disable-line
  module.exports = require('./app.prod');// eslint-disable-line
} else {
  module.exports = require('./app.dev');// eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/config/app.js